"use client";

import { cn } from "@/utils/classnames";
import { BrandSymbol } from "@/components/brand-symbol";
import Link, { LinkProps } from "next/link";

type Props = {
  value?: string;
  img?: string;
  alt?: string;
  collapsed?: boolean;
  loading?: boolean;
  link?: Pick<LinkProps, "href" | "onClick">;
};

export const NavigationLogo = ({
  img,
  alt,
  collapsed,
  loading,
  value,
  link,
}: Props) => {
  const symbol = (
    <BrandSymbol
      value={value}
      loading={loading}
      img={img}
      alt={alt}
      size={collapsed ? "medium" : "xlarge"}
      border
    />
  );

  return (
    <div
      className={cn({
        "mr-2": collapsed,
        "-mt-12 mb-3 flex flex-1 justify-center md:order-1 md:-mt-18 md:mb-0":
          !collapsed,
      })}
    >
      {link?.href ? (
        <Link href={link.href} onClick={link.onClick}>
          {symbol}
        </Link>
      ) : (
        symbol
      )}
    </div>
  );
};
